import { useEffect } from "react";
import image from "./../../styles/legacy/Maintenance-Logo.png";
import { NoContent } from "../components/NoContent";

export const MaintenancePage = () => {
  useEffect(() => {
    document.title = "The Hub - Maintenance Page";
  }, []);

  return (
    <NoContent
      title="Maintenance"
      text="The Hub is on maintenance mode."
      subText={["Sorry for the inconvenience, please try again later."]}
      image={image}
      style={{ margin: "3% auto 0 auto" }}
      conditionButton={false}
    />
  );
};
